export default __webpack_public_path__ + "static/media/search_filter.835ec58c.svg";